var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"check-site-version"},[_vm._v(" / App: "+_vm._s(_vm.appVersion))])
}
var staticRenderFns = []

export { render, staticRenderFns }